var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivationUnknown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 60,
    width: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    d: "M 5.77,0 -2.88,5 V -5 Z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#b9b9b9",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b9b9b9",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2) rotate(180) translate(6,0)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.0824522e-7,-8.25e-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13.154509,296.99999 v -5.26621",
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291675,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291651,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 17.633942,283.77082 h 8.824389"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23424566
    },
    transform: "matrix(1.1295122,0,0,1.1295122,1.8517688,-26.602368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 9.0083076,278.27159 h 1.3987084 v 1.75011 H 9.0083076 Z m 1.3573674,-1.01286 H 9.0496488 v -1.06109 q 0,-0.69591 0.1929253,-1.14377 0.1929254,-0.44786 0.8130429,-1.04042 l 0.620117,-0.61323 q 0.392741,-0.36518 0.564996,-0.68901 0.179145,-0.32384 0.179145,-0.66146 0,-0.61323 -0.454753,-0.99219 -0.447863,-0.37896 -1.1920032,-0.37896 -0.5443251,0 -1.1644423,0.24116 -0.613227,0.24115 -1.2815755,0.70279 v -1.29535 q 0.6476779,-0.39274 1.3091363,-0.58567 0.6683485,-0.19292 1.3780387,-0.19292 1.267795,0 2.032606,0.66835 0.771701,0.66834 0.771701,1.76388 0,0.52366 -0.248047,0.99908 -0.248046,0.46854 -0.868164,1.06109 l -0.606336,0.59256 q -0.323839,0.32384 -0.461643,0.50987 -0.130914,0.17915 -0.186035,0.3514 -0.04134,0.1447 -0.06201,0.3514 -0.02067,0.20671 -0.02067,0.565 z",
    style: {
      fontSize: "14.11111164px",
      fill: "#6a6a6a",
      fillOpacity: 1,
      strokeWidth: 0.23424566
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 13.154509,276.32334 v -5.78168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.8350957e-7,283.77083 H 9.8316551",
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationUnknown);
export default __webpack_public_path__ + "static/media/activation_unknown.23c4e60df3efbe50114c4ca0f736cd5f.svg";
export { ForwardRef as ReactComponent };